import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import AccessibleOutlinedIcon from "@mui/icons-material/AccessibleOutlined";
import AdjustOutlinedIcon from "@mui/icons-material/AdjustOutlined";
import BrushOutlinedIcon from "@mui/icons-material/BrushOutlined";
import ChildFriendlyOutlinedIcon from "@mui/icons-material/ChildFriendlyOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import DesktopMacOutlinedIcon from "@mui/icons-material/DesktopMacOutlined";
import DirectionsCarOutlinedIcon from "@mui/icons-material/DirectionsCarOutlined";
import DoneIcon from "@mui/icons-material/Done";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import EuroOutlinedIcon from "@mui/icons-material/EuroOutlined";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import GpsFixedOutlinedIcon from "@mui/icons-material/GpsFixedOutlined";
import HealingOutlinedIcon from "@mui/icons-material/HealingOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import PermIdentitiyIcon from "@mui/icons-material/PermIdentity";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import SupervisedUserCircleOutlinedIcon from "@mui/icons-material/SupervisedUserCircleOutlined";
import TranslateOutlinedIcon from "@mui/icons-material/TranslateOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import { Icon, type IconProps } from "@mui/material";
import type { ComponentProps } from "react";
import { FranceTravailIcon } from "./svg/franceTravail";
import { GoogleMapsIcon } from "./svg/googleMaps";

export const iconMapping = {
  AccessibleOutlinedIcon,
  AdjustOutlinedIcon,
  ChildFriendlyOutlinedIcon,
  DesktopMacOutlinedIcon,
  DirectionsCarOutlinedIcon,
  GavelOutlinedIcon,
  HealingOutlinedIcon,
  HomeOutlinedIcon,
  MonetizationOnOutlinedIcon,
  PeopleAltOutlinedIcon,
  PeopleOutlineOutlinedIcon,
  PermIdentitiyIcon,
  SchoolOutlinedIcon,
  TranslateOutlinedIcon,
  WorkOutlineOutlinedIcon,
  CloseOutlinedIcon,
  SupervisedUserCircleOutlinedIcon,
  DoneOutlineIcon,
  FranceTravailIcon,
  AccessTimeIcon,
  DoneAllIcon,
  ErrorOutlineIcon,
  EuroOutlinedIcon,
  DoneIcon,
  InfoOutlinedIcon,
  AccessTimeOutlinedIcon,
  GpsFixedOutlinedIcon,
  DescriptionOutlinedIcon,
  WhatsAppIcon,
  HowToRegOutlinedIcon,
  BrushOutlinedIcon,
  GoogleMapsIcon,
} as const;

export type TIconSVG = keyof typeof iconMapping;

export type TIconSVGProps = ComponentProps<typeof AdjustOutlinedIcon> & { icon: string };

export type TIconFromNameProps = Omit<IconProps, "children"> & {
  fallbackIcon?: string;
  icon?: string | null;
};

export const isIconKey = (icon: string): icon is keyof typeof iconMapping => iconMapping[icon] !== undefined;

export const IconSVG = ({ icon, ...props }: TIconSVGProps) => {
  if (!isIconKey(icon)) {
    return null;
  }
  const Icon = iconMapping[icon];
  return <Icon {...props} />;
};

// ComplexIcon ? IconFromName ? What's the best name for this component ?
export const IconFromName = ({
  icon,
  fallbackIcon,
  baseClassName = "material-icons-outlined",
  ...props
}: TIconFromNameProps) => {
  const iconName = icon || fallbackIcon;
  if (!iconName) {
    return null;
  }
  if (isIconKey(iconName)) {
    return <IconSVG icon={iconName} {...(props as Omit<TIconSVGProps, "icon">)} />;
  }
  return (
    <Icon baseClassName={baseClassName} {...props}>
      {iconName}
    </Icon>
  );
};
